export const timeTypes = {
  startTime: 'startTime',
  endTime: 'endTime',
};
export const dateTypes = {
  startAt: 'startAt',
  endAt: 'endAt',
};
export const weekDaysKeys = Array.from(Array(7).keys());
